import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostData_importBatches_idUndo_preview = z.any()
export type TagsPostData_importBatches_idUndo_preview = z.infer<typeof tagsPostData_importBatches_idUndo_preview>

export const paramsPostData_importBatches_idUndo_preview = z.object({ "id": z.string().uuid() })
export type ParamsPostData_importBatches_idUndo_preview = z.infer<typeof paramsPostData_importBatches_idUndo_preview>

export const bodyPostData_importBatches_idUndo_preview = z.object({ "undoToken": z.string().min(64).max(64).optional() })
export type BodyPostData_importBatches_idUndo_preview = z.infer<typeof bodyPostData_importBatches_idUndo_preview>

export const responsePostData_importBatches_idUndo_preview = z.object({ "payload": z.object({ "batchId": z.string(), "canUndo": z.boolean(), "undone": z.boolean(), "undoToken": z.string(), "blockers": z.array(z.string()), "records": z.number().int() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostData_importBatches_idUndo_preview = z.infer<typeof responsePostData_importBatches_idUndo_preview>

interface IPostData_importBatches_idUndo_preview extends BaseMethodType {
  tags: TagsPostData_importBatches_idUndo_preview,
  params: ParamsPostData_importBatches_idUndo_preview,
  body: BodyPostData_importBatches_idUndo_preview,
  response: ResponsePostData_importBatches_idUndo_preview
}
export const URL = '/data-import/batches/:id/undo-preview'
export const validation = {
  post: {
    tags: tagsPostData_importBatches_idUndo_preview,
    params: paramsPostData_importBatches_idUndo_preview,
    body: bodyPostData_importBatches_idUndo_preview,
    response: responsePostData_importBatches_idUndo_preview
  }
}
export interface Data_importBatches_idUndo_preview extends BaseRouteType {
  post: IPostData_importBatches_idUndo_preview
}